import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'smsCredits' })
export class SmsCreditsPipe implements PipeTransform {
  transform(value: string): number {
    return value ? Math.ceil(value.length / 140) : 0;
  }
}
